import $ from 'jquery'
import {getCookie, checkCookie, setCookie} from "./data/cookies";


let popup = false;
let popups = false;
let popupPriority = 666;
let popupExpire = 0;
let popupID = 0;

let popupActive;


function initPopups() {
    setListeners();
    $(window).on('load', function () {

        getCookie('');

        popupsAuto();

    });
}

function setListeners() {
    $('.publisher-popups-button__close,.publisher-popups__overlay').on('click', function (event) {
        
        var d = new Date();
        const expireFormula = (popupExpire * 24 * 60 * 60 * 1000);
        d.setTime(d.getTime() + (expireFormula));
        const cookieExpire = "expires=" + d.toUTCString();


        setCookie(popupID, 'appeared', cookieExpire);
        togglePopup(this)
    });


    $('a[data-action="open:popup"]').on('click', function (event) {
        event.preventDefault();
        const selector = '.publisher-popups__popup[data-popup-id="' + $(this).data('popup-id') + '"]';
        popupEvent(selector, event);
    });

    $(document).on('open:popup', function (event, id, data) {
        event.preventDefault();
        const selector = '.publisher-popups__popup[data-popup-id="' + id + '"]';
        popupEvent(selector, event, data);
    });
}


function togglePopup(obj) {

    $('.publisher-popups').removeClass('popup-open');
    $('body').toggleClass('popup-open');
    $('.publisher-popups__popup').removeClass('popup-loaded');
    setTimeout(function () {
        $('.publisher-popups__popup.popup-open').addClass('popup-open');
    }, 500);

}


function popupsAuto(loop = 0) {
    popups = $('.publisher-popups__popup[data-popup-type="trigger_auto"]');

    if (popups.length > 0 && popups.length > loop) {
        for (let i = loop, len = popups.length; i < len; i++) {
            if ($(popups[i]).data('popup-priority') < popupPriority) {
                popup = $(popups[i]);

                popupID = $(popup).data('popup-id');
                popupPriority = $(popup).data('popup-priority');
                popupExpire = $(popup).data('popup-expire');
                popup = $('.publisher-popups__popup[data-popup-priority="' + popupPriority + '"]');


            }
        }

        // show priority 1
        var d = new Date();
        const expireFormula = (popupExpire * 24 * 60 * 60 * 1000);
        d.setTime(d.getTime() + (expireFormula));
        const cookieName = $(popup).data('popup-id');
        const cookieValue = 'appeared';
        const cookieExpire = "expires=" + d.toUTCString();

        
        const validation = checkCookie(cookieName, cookieValue, cookieExpire, false);
        if (!validation) {
            popupEvent(popup);
        } else {
            popupPriority = 666;
            popupExpire = false;
            popup = false;
            loop += 1;
            popupsAuto(loop)

        }
    }
}


function popupEvent(obj, event = [], data = []) {

    if (!$('body').hasClass('popup-open')) {
        $('.gallery-tile').removeClass('active');
        $('.publisher-popups__popup').removeClass('popup-open');
        $('.publisher-popups__popup').removeClass('popup-loaded');

        $('body').addClass('popup-open');
        let $obj = $(event.currentTarget);
        let tileID = $obj.data('popup-tile-id');
        $('.gallery-tile[data-id="' + tileID + '"]').addClass('active');

        
        $(obj).addClass('popup-open');


        // $(document).trigger('pub:popup:vendors');


        setTimeout(function () {
            $('.publisher-popups__popup.popup-open').addClass('popup-loaded');
        }, 10);

    }


}


export default initPopups;
